(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-drzzl-pdp]').forEach((section) => {
      if (section.dataset.refreshReady) return;
      section.dataset.refreshReady = 'true';
      const form = section.querySelector('form[action*="/cart/add"]');
      const input = form?.querySelector('input[name="quantity"]');
      section.querySelectorAll('[data-quantity-step]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!input) return;
          if (button.dataset.quantityStep === 'up') input.stepUp();
          else input.stepDown();
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      const gallery = section.querySelector('[data-pdp-gallery]');
      const mainImage = gallery?.querySelector('[data-pdp-main-image]');
      gallery?.querySelectorAll('[data-pdp-thumb]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!mainImage) return;
          mainImage.srcset = button.dataset.srcset || '';
          mainImage.src = button.dataset.src;
          mainImage.alt = button.dataset.alt || '';
          gallery.querySelectorAll('[data-pdp-thumb]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
      const buy = form?.querySelector('[type="submit"]');
      const sticky = section.querySelector('[data-pdp-sticky]');
      const stickyButton = sticky?.querySelector('button');
      if (buy && sticky && stickyButton && 'IntersectionObserver' in window) {
        stickyButton.addEventListener('click', () => {
          if (form.reportValidity()) form.requestSubmit(buy);
        });
        const observer = new IntersectionObserver((entries) => {
          const show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
          sticky.hidden = !show;
          document.body.classList.toggle('drzzl-purchase-bar-visible', show);
        });
        observer.observe(buy);
        let scheduled = false;
        const updateSticky = () => {
          scheduled = false;
          if (!section.isConnected) { observer.disconnect(); window.removeEventListener('scroll', onScroll); return; }
          const show = buy.getBoundingClientRect().bottom < 0;
          sticky.hidden = !show;
          document.body.classList.toggle('drzzl-purchase-bar-visible', show);
        };
        const onScroll = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(updateSticky); } };
        window.addEventListener('scroll', onScroll, { passive: true });
        updateSticky();
      }
      section.querySelectorAll('[data-recipe-carousel]').forEach((carousel) => {
        const track = carousel.querySelector('[data-recipe-track]');
        const cards = [...track.querySelectorAll('.drzzl-product-recipes__card')];
        const pause = carousel.querySelector('[data-recipe-pause]');
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        let paused = motion.matches;
        let hovering = false;
        let focused = false;
        let visible = false;
        const updatePause = () => {
          pause.setAttribute('aria-pressed', String(paused));
          pause.textContent = paused ? pause.dataset.playLabel : pause.dataset.pauseLabel;
        };
        const move = (direction) => {
          const step = cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
          const max = track.scrollWidth - track.clientWidth;
          const next = track.scrollLeft + direction * step;
          track.scrollTo({ left: next > max + 4 ? 0 : next < -4 ? max : Math.min(max, next), behavior: motion.matches ? 'instant' : 'smooth' });
        };
        pause.addEventListener('click', () => { paused = !paused; updatePause(); });
        carousel.querySelector('[data-recipe-prev]').addEventListener('click', () => { paused = true; updatePause(); move(-1); });
        carousel.querySelector('[data-recipe-next]').addEventListener('click', () => { paused = true; updatePause(); move(1); });
        track.addEventListener('pointerdown', () => { paused = true; updatePause(); });
        carousel.addEventListener('pointerenter', () => { hovering = true; });
        carousel.addEventListener('pointerleave', () => { hovering = false; });
        carousel.addEventListener('focusin', () => { focused = true; });
        carousel.addEventListener('focusout', () => { focused = false; });
        const onMotion = () => { if (motion.matches) { paused = true; updatePause(); } };
        motion.addEventListener('change', onMotion);
        const visibility = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }, { threshold: .2 });
        visibility.observe(carousel);
        const timer = setInterval(() => {
          if (!carousel.isConnected) { clearInterval(timer); visibility.disconnect(); motion.removeEventListener('change', onMotion); return; }
          if (visible && !document.hidden && !paused && !hovering && !focused) move(1);
        }, 5000);
        updatePause();
      });
      const packagingFeedback = section.querySelector('.drzzl-packaging-interest');
      if (packagingFeedback?.querySelector('[role="status"],[role="alert"]')) {
        packagingFeedback.open = true;
        packagingFeedback.querySelector('[role="status"],[role="alert"]').focus();
      }
      const variantSelect = form?.querySelector('select[name="id"]');
      variantSelect?.addEventListener('change', () => {
        const selected = variantSelect.selectedOptions[0];
        section.querySelectorAll('[data-pdp-button-price]').forEach((element) => {
          if (selected?.dataset.price) element.textContent = selected.dataset.price;
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

